export default [
  {
    meta: {
      icon: "iconfont iconjichuxinxiguanli",
      title: "长城新零售",
      uri: "/newRetail/oraNewRetail",
    },
    isThree: true,
    path: "/newRetail/oraNewRetail",
    subMenus: [
      {
        meta: {
          icon: "iconfont iconjichuxinxiguanli",
          title: "透明订单信息",
          uri: "/newRetail/oraNewRetail/cardOrderDetail",
        },
        component: () => import("./cardOrderDetail.vue"),
        path: "/newRetail/oraNewRetail/cardOrderDetail",
      },
      {
        meta: {
          icon: "iconfont iconjichuxinxiguanli",
          title: "订单管理",
          uri: "/newRetail/oraNewRetail/orderControl",
        },
        component: () => import("./orderControl.vue"),
        path: "/newRetail/oraNewRetail/orderControl",
      },
      {
        meta: {
          icon: "iconfont iconjichuxinxiguanli",
          title: "退款订单",
          uri: "/newRetail/oraNewRetail/refundOrder",
        },
        component: () => import("./refundOrder.vue"),
        path: "/newRetail/oraNewRetail/refundOrder",
      },
      {
        meta: {
          icon: "iconfont iconjichuxinxiguanli",
          title: "POS交易流水",
          uri: "/newRetail/oraNewRetail/turnoverSearch",
        },
        component: () => import("./turnoverSearch.vue"),
        path: "/newRetail/oraNewRetail/turnoverSearch",
      },
      {
        meta: {
          icon: "iconfont iconjichuxinxiguanli",
          title: "财务结算统计",
          uri: "/newRetail/oraNewRetail/paymentSettlement",
        },
        component: () => import("./paymentSettlement/index.vue"),
        path: "/newRetail/oraNewRetail/paymentSettlement",
      },
    ],
  },
];
